import React, { createContext, useContext, useMemo } from "react";

type ThemeConfig = {
  accentColour: string;
};

type Props = {
  children: React.ReactNode;
  theme?: Partial<ThemeConfig>;
};

const defaultTheme = {
  accentColour: "#015294"
};

export const ThemeContext = createContext<ThemeConfig>(defaultTheme);

const Theme = ({ children, theme }: Props) => {
  const nestedTheme = useContext(ThemeContext);
  const themeWithDefaults = useMemo(() => {
    return { ...defaultTheme, ...nestedTheme, ...theme };
  }, [theme]);

  return (
    <ThemeContext.Provider value={themeWithDefaults}>
      {children}
    </ThemeContext.Provider>
  );
};

export default Theme;
